import { motion } from "framer-motion";

/**
 * Line-by-line masked reveal. Each `line` is animated inside an overflow-hidden mask.
 * Pass an array of strings; they render in sequence with stagger.
 */
export function MaskedLines({
  lines,
  className = "",
  itemClassName = "",
  delay = 0.15,
  stagger = 0.14,
  duration = 0.9,
}) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="mask-line">
          <motion.span
            className={`block ${itemClassName}`}
            initial={{ y: "115%" }}
            animate={{ y: "0%" }}
            transition={{
              duration,
              ease: [0.22, 1, 0.36, 1],
              delay: delay + i * stagger,
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

/** Word-level masked reveal (kept for optional micro-headlines). */
export function MaskedWords({ text, className = "", delay = 0.2 }) {
  const words = text.split(" ");
  return (
    <span className={className}>
      {words.map((w, i) => (
        <span key={i} className="mask-line inline-block mr-[0.25em]">
          <motion.span
            className="inline-block"
            initial={{ y: "115%" }}
            animate={{ y: "0%" }}
            transition={{
              duration: 0.8,
              ease: [0.22, 1, 0.36, 1],
              delay: delay + i * 0.05,
            }}
          >
            {w}
          </motion.span>
        </span>
      ))}
    </span>
  );
}
